import { B2CPolicy, IEnvironmentVariables } from 'src/environments/IEnvironment';

export const b2cPolicies: B2CPolicy = {
  names: {
    signUpSignIn: 'B2C_1A_SignUp_SignIn',
    signUpSignInRegence: 'B2C_1A_SignUp_SignIn_Regence',
    signUpSignInportalextsso: 'B2C_1A_SignUp_SignIn',
    resetPassword: 'B2C_1A_PasswordReset',
  },
  authorityBaseUrl: 'https://mncportalstage2.b2clogin.com/tfp/mncportalstage2.onmicrosoft.com',
};

const BASE_URL = 'https://portalstg2.mynexuscare.com/';
const REDIRECT_URI = 'https://{client}portalstg2.mynexuscare.com/';

const API_URL = {
  Platform: 'https://api-platform.portalstg2.mynexuscare.com',
  HH: 'https://api-homehealth.portalstg2.mynexuscare.com',
  PAC: 'https://api-pacim.portalstg2.mynexuscare.com',
  DMEPOS: 'https://api-dmepos.portalstg2.mynexuscare.com',
  SDoH: 'https://api-sdoh.portalstg2.mynexuscare.com',
  SP: 'https://api-specialtyprograms-gateway.portalstg2.mynexuscare.com',
  DocumentGateway: 'https://api-document-gateway.portalstg2.mynexuscare.com',
  NotificationGateway: 'https://api-notification-gateway.portalstg2.mynexuscare.com',
};

const consentScopes = [
  'https://mncportalstage2.onmicrosoft.com/api/api.Write',
  'https://mncportalstage2.onmicrosoft.com/api/api.Read',
  'https://mncportalstage2.onmicrosoft.com/api/user_impersonation',
];

export const environment: IEnvironmentVariables = {
  production: true,
  b2cPolicies: b2cPolicies,
  baseUrl: BASE_URL,
  appInsightsConnectionString: 'InstrumentationKey=92d59589-badd-4d9e-ab43-d1e4efc8a83c;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=7e988676-e02e-410a-9927-25a6adbdede1',
  apiUrl: API_URL.HH,
  apiPlatformUrl: API_URL.Platform,
  apiDocumentUrl: API_URL.DocumentGateway,
  apiUrlPacIM: API_URL.PAC,
  apiDMEPOSUrl: API_URL.DMEPOS,
  apiSDoHUrl: API_URL.SDoH,
  apiSpecialtyProgramsUrl: API_URL.SP,
  apiNotificationsUrl: API_URL.NotificationGateway,
  routerUrl: 'https://resourcerouter.portalstg2.mynexuscare.com',
  sdohUrl: 'https://sdoh.portalstg2.mynexuscare.com/',
  codeManagementUrl: 'https://web-codemanagement.portalstg2.mynexuscare.com',
  extssoBaseUrl: BASE_URL,
  hhProviderFinderUrl : 'https://carelonsolutions--full.sandbox.my.salesforce-sites.com/ProviderFinder',
  authConfig: {
    config: {
      auth: {
        clientId: 'dee9264f-976c-470c-8bca-816fe67ddbdc',
        postLogoutRedirectUri: REDIRECT_URI,
        redirectUri: REDIRECT_URI,
        knownAuthorities: ['mncportalstage2.b2clogin.com'],
      },
      system: {},
    },
    angularConfig: {
      extraQueryParameters: {
        prompt: 'select_account',
      },
      consentScopes: [...consentScopes, 'openid', 'profile'],
      protectedResourceMap: [
        ...Object.values(API_URL).map((url) => [`${url}/*`, consentScopes]),
      ],
    },
  },
  registryUrl: `${API_URL.Platform}/api/app-registry`,
};


